import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { captureAppError } from "./lib/observability";
import "./index.css";

const root = document.getElementById("root");
if (!root) {
  throw new Error("Root element #root not found");
}

window.addEventListener("error", (event) => {
  captureAppError("Browser runtime error", event.error ?? event.message, { filename: event.filename, lineno: event.lineno });
});

window.addEventListener("unhandledrejection", (event) => {
  captureAppError("Unhandled promise rejection", event.reason);
});

createRoot(root).render(
  <StrictMode>
    <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
